import client from '../../../../common/client';

export const GET_FAVORITES = 'GET_FAVORITES';
export const FAVORITE_LIBRARY_VIDEO = 'FAVORITE_LIBRARY_VIDEO';
export const UNFAVORITE_LIBRARY_VIDEO = 'UNFAVORITE_LIBRARY_VIDEO';
export const FAVORITE_EPISODE_VIDEO = 'FAVORITE_EPISODE_VIDEO';
export const UNFAVORITE_EPISODE_VIDEO = 'UNFAVORITE_EPISODE_VIDEO';

export const getFavorites = () => ({
  promise: client.get('favorites/all', null, {
    credentials: 'include', // Required for browser to respect Set-Cookie headers
  }),
  type: GET_FAVORITES,
});

export const favoriteLibraryVideo = (libraryVideoId, categoryId) => ({
  promise: client.post(`favorites/library`, { libraryVideoId }),
  type: FAVORITE_LIBRARY_VIDEO,
  libraryVideoId,
});

export const unfavoriteLibraryVideo = (libraryVideoId, categoryId) => ({
  promise: client.delete(`favorites/library/${libraryVideoId}`),
  type: UNFAVORITE_LIBRARY_VIDEO,
  libraryVideoId,
});

export const favoriteEpisodeVideo = episodeId => ({
  promise: client.post(`favorites/episodes`, { episodeId }),
  type: FAVORITE_EPISODE_VIDEO,
  episodeId,
});

export const unfavoriteEpisodeVideo = episodeId => ({
  promise: client.delete(`favorites/episodes/${episodeId}`),
  type: UNFAVORITE_EPISODE_VIDEO,
  episodeId,
});



// WEBPACK FOOTER //
// ./src/subscription/library/favorites/redux/actions.js